(() => {
  const config = document.getElementById('axtlan-terms-locale');
  const policyLink = config?.dataset.policyLink;
  const errorMessage = config?.dataset.errorMessage;
  const rawPolicyUrl = config?.dataset.policyUrl || '';
  const policyUrl = /^\/(?:[a-z]{2}(?:-[a-z]{2,4})?\/)?policies\/terms-of-service$/i.test(rawPolicyUrl)
    ? rawPolicyUrl : '/policies/terms-of-service';
  if (!policyLink || !errorMessage || !document.body ||
      /translation missing/i.test(`${policyLink} ${errorMessage}`)) return;

  const adaptedLabels = new WeakSet();
  const adaptedErrors = new WeakSet();
  const pending = new Set();
  let scheduled = false;

  function localize(widget) {
    if (!widget.isConnected) return;
    const input = widget.querySelector('.rale-checkbox input[type="checkbox"]');
    const label = widget.querySelector('label.rale-message');
    if (!input || !label || label.htmlFor !== input.id) return;

    const links = Array.from(label.querySelectorAll('a.rale-link.rale-policy'));
    const children = Array.from(label.childNodes);
    const tags = children.filter(node => node.nodeType === 3).map(node => node.data).join('');
    const knownMessage = links.length === 3 &&
      ['[MX]', '[EN]', '[DE]'].every(tag => tags.includes(tag)) &&
      tags.replace(/\[(?:MX|EN|DE)\]/g, '').trim() === '';
    const safeLinks = links.length > 0 && links.every(link =>
      link.parentElement === label &&
      ['/policies/terms-of-service', policyUrl].includes(link.getAttribute('href')) &&
      link.getAttribute('data-policy') === 'terms-of-service' &&
      Array.from(link.childNodes).every(node => node.nodeType === 3));
    const safeChildren = children.every(node => node.nodeType === 3 || links.includes(node));

    if (!safeLinks || !safeChildren || (!knownMessage && !adaptedLabels.has(label))) return;
    for (const node of children) {
      if (node.nodeType === 3 && node.data !== '') node.data = '';
    }
    if (links[0].textContent !== policyLink) links[0].textContent = policyLink;
    if (links[0].getAttribute('href') !== policyUrl) links[0].setAttribute('href', policyUrl);
    for (const link of links.slice(1)) {
      if (link.textContent !== '') link.textContent = '';
      if (!link.hidden) link.hidden = true;
      if (link.style.display !== 'none') link.style.display = 'none';
    }
    adaptedLabels.add(label);

    const error = widget.querySelector('.rale-error');
    if (!error || !Array.from(error.childNodes).every(node => node.nodeType === 3)) return;
    const text = error.textContent;
    const knownError = text.includes('Español (MX):') && text.includes('English (EN):') &&
      text.includes('Deutsch (DE):') && text.includes('Please agree to the terms and conditions');
    if (knownError || adaptedErrors.has(error)) {
      if (text !== errorMessage) error.textContent = errorMessage;
      adaptedErrors.add(error);
    }
  }

  function schedule(widget) {
    if (!widget || pending.size >= 16) return;
    pending.add(widget);
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      const widgets = Array.from(pending);
      pending.clear();
      widgets.forEach(localize);
    });
  }

  const observer = new MutationObserver(records => {
    for (const record of records) {
      const element = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      schedule(element?.closest('.rale-widget'));
      for (const node of record.addedNodes) {
        if (node.nodeType !== 1) continue;
        schedule(node.closest('.rale-widget'));
        for (const widget of node.querySelectorAll('.rale-widget')) schedule(widget);
      }
    }
  });
  observer.observe(document.body, { childList: true, characterData: true, subtree: true });
  document.querySelectorAll('.rale-widget').forEach(schedule);
})();
